import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Card from '../Card';
import { CercleSolde } from '../MesInfos/CardCompte';
import { toEuros } from '../../App_Code/Utils';

export const ExplicationSolde = ({ Solde }) =>
    // eslint-disable-next-line no-nested-ternary
    (Solde >= 0.0 ? (
        <p>
            Vous ne devez rien.
        </p>
    ) :
        (
            <p>
                Vous devez {toEuros(Solde * -1)} €
            </p>
        ));

const CardInfos = ({ Civilite, Nom, Cpt, ComptaEnReprise_Visible, EtatGestion, EstMembreCS }) => (
    <Card Titre={CardInfos.titleName} SousTitre={`${Civilite} ${Nom}`}>
        { ((ComptaEnReprise_Visible==0 && EtatGestion==1) || (ComptaEnReprise_Visible==2 && EtatGestion==1 && !EstMembreCS )) ?
            <React.Fragment>
                <div className="card-text mb-3">
                        <p style={{fontSize:"14px",fontWeight:"bold",padding:"20px 0 20px 20px"}}>Reprise comptable en cours.
                        <br/>L'accès aux informations est momentanément suspendu.</p>
                </div>
            </React.Fragment>
            :
            <React.Fragment>
                <div className="card-text mb-3">
                        <CercleSolde {...Cpt} />
                        <ExplicationSolde {...Cpt} />
                </div>
                <div className="d-flex flex-wrap">
                    <Link to="/MesInformations" className="btn btn-outline-primary mt-2">
                        Voir mes informations
                    </Link>
                    <Link to="/MesInformations/Paiement" className="btn btn-outline-orange ml-3 mt-2" title="Redirection vers la page de paiement">
                        Payer
                    </Link>
                </div>
            </React.Fragment> 
        }
    </Card>
);
CardInfos.displayName = 'CardInfos';
CardInfos.titleName = 'Mes informations';
CardInfos.requiredProps = [
    'Civilite', // Civilité du propriétaire
    'Nom', // Nom du propriétaire
    'Cpt', // Informations sur le compte du propriétaire
    'ComptaEnReprise_Visible', // Informations voir compta reprise
    'EtatGestion', // Informations copro en reprise reprise
    'EstMembreCS', // propriétaire CS ou non
];

function mapStateToProps({
    AdhStore: { EstMembreCS }, 
    ProStore: {
        Pro: {
            Ind: { Civilite, Nom },
            Cpt,
        },
    },
    SynStore: {
        Syn: {
            ComptaEnReprise_Visible,
        },
    },
    CopStore: {
        Cop: {
            EtatGestion,
        },
    },
}) {
    return { Civilite, Nom, Cpt, ComptaEnReprise_Visible, EtatGestion, EstMembreCS };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardInfos));



// WEBPACK FOOTER //
// ./src/components/Accueil/CardInfos.js